@if (idktostamm$ | async; as  idktostamm) {
  <soft-kundeninfo-leiste [idktostamm]="idktostamm"></soft-kundeninfo-leiste>
}
